import { environment } from "src/environments/environment"

// 是否为特殊部署
export const IS_SPECIAL_DEPLOY = environment.isSpecialDeploy

// 页面标题
export const APP_TITLE = IS_SPECIAL_DEPLOY ? 'AI 医生' : '小景 AI 医生'

// 聊天列表默认对话标题
export const DIA_LIST_TITLE = IS_SPECIAL_DEPLOY ? 'SIHOOM AI 医生' : '小景AI医生'

// 聊天对话界面自我介绍
export const AI_INTRODUCE = `您好，我是${IS_SPECIAL_DEPLOY ? '' : '小景'}AI医生，请问您需要咨询什么问题？`

// WebView跳转小程序时携带的参数值
export const AI_WEBVIEW = 'ai_webview'

// 未提供音频录制权限提示文本
export const NON_AUDIO_AUTHORITY = '抱歉，由于您未授权音频录制权限，将无法使用语音功能。'